/**
 * Default shape for the collection-create form.
 *
 * `seadrop` always exists (with a `public_stage` sub-object) even when
 * the chosen contract type doesn't use it, so per-field setters don't
 * have to special-case undefined.
 */
export const emptyForm = () => ({
  name: '',
  symbol: '',
  contract_type: 'erc721a',
  drop_strategy: 'none',
  chain_id: '',
  network_name: '',
  description: '',
  cover_image_url: '',
  metadata_base_uri: '',
  external_url: '',
  royalty_basis_points: 500,
  royalty_recipient_address: '',
  max_supply: 0,
  seadrop: {
    creator_payout_address: '',
    public_stage: {
      name: 'Public',
      price_wei: '',
      max_per_wallet: 0,
      max_total: 0,
      start_time: '',
      end_time: '',
    },
  },
});
